import styled from "styled-components";


export const ImagesWithProjectsListContainer = styled.div`

  .loader-additional-list {
    position: relative;
		animation: fadeIn 0.3s ease-in-out;

    > div:first-child {
      display: none;
    }

		>div:last-child {
				padding-top: 0;
		}
  }

	.component-container {
		padding: 0;
		margin-top: var(--spacing-component);
	}

	.no-projects-found {
		border-top: none;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`